import { render, staticRenderFns } from "./SetupUIPlugins.vue?vue&type=template&id=77c3eb63&scoped=true&"
import script from "./SetupUIPlugins.vue?vue&type=script&lang=js&"
export * from "./SetupUIPlugins.vue?vue&type=script&lang=js&"
import style0 from "./SetupUIPlugins.vue?vue&type=style&index=0&id=77c3eb63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c3eb63",
  null
  
)

export default component.exports